import { TaskItem } from "@tiptap/extension-task-item";
import { TaskList as TiptapTaskList } from "@tiptap/extension-task-list";
import { ActionButton } from "../../components";

export const TaskList = TiptapTaskList.extend({
	addOptions() {
		return {
			...this.parent?.(),
			HTMLAttributes: {
				class: "task-list"
			},
			taskItem: {
				HTMLAttributes: {
					class: "task-list-item"
				}
			},
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.commands.toggleTaskList(),
					isActive: () => editor.isActive("taskList") || false,
					disabled: false,
					icon: "ListTodo",
					shortcutKeys: ["shift", "mod", "9"],
					tooltip: t("editor.tasklist.tooltip")
				}
			})
		};
	},

	addExtensions() {
		return [TaskItem.configure(this.options.taskItem)];
	}
});
